import { render } from "./FormLayoutBlock.v1.vue?vue&type=template&id=324eea00&scoped=true"
import script from "./FormLayoutBlock.v1.vue?vue&type=script&lang=js"
export * from "./FormLayoutBlock.v1.vue?vue&type=script&lang=js"

import "./FormLayoutBlock.v1.vue?vue&type=style&index=0&id=324eea00&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324eea00"]])

export default __exports__